export const imageResizer = (image, width, height) => {
  if (!image) {
    return null
  }

  if (!image.includes("cloudfront.net")) {
    return image
  }

  const splittedImage = image.split("/")
  splittedImage.splice(splittedImage.length - 1, 0, `${width}x${height}`)
  return splittedImage.join("/")
}
